// Generated by tools/generate-authorization-scope.mjs; edit tools/contracts/authorization-scope.cts.
// Appendix one of the supplied single-project portrait agreement. Values are an
// application snapshot; they never override the priced offer or grant rights.
export type AuthorizationScope = { version: 1; values: Record<string, string | string[]> };
export type ScopeField = { key: string; label: string; options?: string[]; multiple?: boolean; hint?: string; optional?: boolean; when?: [string, string]; date?: boolean };
const AUTHORIZATION_SCOPE_FIELDS: ScopeField[] = [
  { key: "materialId", label: "人像素材编号" },
  { key: "purpose", label: "项目用途", hint: "具体作品／商品／活动及配套物料，说明是否包含预告、海报、切片等" },
  { key: "actions", label: "被许可行为", hint: "复制、剪辑、展示、投放、传播等逐项填写" },
  { key: "licenseType", label: "授权类型", options: ["非独家", "独家"] },
  { key: "exclusiveScope", label: "独家限制范围", when: ["licenseType", "独家"] },
  { key: "term", label: "授权期限", options: ["限时", "长期"], optional: true },
  { key: "startsAt", label: "授权开始日期", date: true, when: ["term", "限时"] },
  { key: "endsAt", label: "授权结束日期", date: true, when: ["term", "限时"] },
  { key: "region", label: "授权地域" },
  { key: "channels", label: "媒介与渠道", hint: "填写媒介、渠道及使用的平台账号" },
  { key: "industries", label: "行业与题材" },
  { key: "excludedIndustries", label: "排除行业与题材", hint: "无排除项请填写“无”" },
  { key: "character", label: "人物角色、服装与台词" },
  { key: "voice", label: "声音使用", options: ["不含", "含"] },
  { key: "voiceScope", label: "声音另行许可范围", when: ["voice", "含"] },
  { key: "ai", label: "AI 处理方式", options: ["不允许", "换脸", "动作驱动", "形象生成", "其他"], multiple: true },
  { key: "aiOther", label: "其他 AI 处理方式", when: ["ai", "其他"] },
  { key: "dedicatedTraining", label: "模型训练与复用：专属模型训练", hint: "未勾选均视为不允许", options: ["允许", "不允许"] },
  { key: "generalTraining", label: "通用模型训练", options: ["允许", "不允许"] },
  { key: "reuse", label: "跨项目复用", options: ["允许", "不允许"] },
  { key: "digitalDouble", label: "数字分身持续调用", options: ["不涉及", "涉及"] },
  { key: "digitalDoubleScope", label: "数字分身调用安排", hint: "账号、用途、期限及审稿安排", when: ["digitalDouble", "涉及"] },
  { key: "providers", label: "技术服务商", hint: "模型／制作服务商名称、处理地点、保存期限；不涉及请填写“不涉及”" },
  { key: "deliverables", label: "交付物", hint: "类型、数量、格式、分辨率／时长、质量标准" },
  { key: "other", label: "其他", optional: true },
];
function scopeFieldVisible(field: ScopeField, values: AuthorizationScope["values"]) {
  if (!field.when) return true;
  const value = values[field.when[0]];
  return Array.isArray(value) ? value.includes(field.when[1]) : value === field.when[1];
}
function authorizationScopeError(scope: AuthorizationScope): { key: string; message: string } | null {
  for (const field of AUTHORIZATION_SCOPE_FIELDS) {
    if (!scopeFieldVisible(field, scope.values)) continue;
    const value = scope.values[field.key];
    if (field.optional && value === undefined) continue;
    if (field.options) {
      const selected = Array.isArray(value) ? value : typeof value === "string" && value ? [value] : [];
      if (!selected.length || (!field.multiple && (Array.isArray(value) || selected.length !== 1)) || (field.multiple && !Array.isArray(value))
        || selected.some(option => !field.options!.includes(option)) || new Set(selected).size !== selected.length
        || (field.key === "ai" && selected.includes("不允许") && selected.length !== 1)) return { key: field.key, message: `请选择${field.label}` };
    } else if (typeof value !== "string" || value.length > 500 || (!field.optional && !value.trim())) return { key: field.key, message: `请填写${field.label}（最多 500 字）` };
    if (field.date && (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value) || !Number.isFinite(Date.parse(value)) || new Date(value).toISOString().slice(0, 10) !== value)) return { key: field.key, message: `请填写有效的${field.label}` };
  }
  if (scope.values.term === "限时" && String(scope.values.endsAt) <= String(scope.values.startsAt)) return { key: "endsAt", message: "授权结束日期须晚于开始日期" };
  return null;
}
function parseAuthorizationScope(value: unknown): AuthorizationScope | null {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const row = value as Record<string, unknown>;
  if (row.version !== 1 || Object.keys(row).some(key => !["version", "values"].includes(key)) || !row.values || typeof row.values !== "object" || Array.isArray(row.values)) return null;
  const raw = row.values as Record<string, unknown>;
  if (Object.keys(raw).some(key => !AUTHORIZATION_SCOPE_FIELDS.some(field => field.key === key))) return null;
  const values: AuthorizationScope["values"] = {};
  for (const field of AUTHORIZATION_SCOPE_FIELDS) {
    const item = raw[field.key];
    if (item === undefined) continue;
    if (typeof item === "string" && item.length <= 500) values[field.key] = item.trim();
    else if (Array.isArray(item) && item.length <= 5 && item.every(entry => typeof entry === "string" && entry.length <= 30)) values[field.key] = [...item];
    else return null;
  }
  const scope: AuthorizationScope = { version: 1, values };
  if (authorizationScopeError(scope)) return null;
  // Discard stale conditional answers before freezing or fingerprinting a request.
  for (const field of AUTHORIZATION_SCOPE_FIELDS) if (!scopeFieldVisible(field, values)) delete values[field.key];
  return scope;
}
function authorizationScopeRows(scope: AuthorizationScope) {
  return AUTHORIZATION_SCOPE_FIELDS.filter(field => scopeFieldVisible(field, scope.values) && !(field.key === "term" && scope.values.term === undefined)).map(field => ({
    label: field.label, value: Array.isArray(scope.values[field.key]) ? (scope.values[field.key] as string[]).join("、") : String(scope.values[field.key] || "无"),
  }));
}
export { AUTHORIZATION_SCOPE_FIELDS, scopeFieldVisible, authorizationScopeError, parseAuthorizationScope, authorizationScopeRows };
